import React, {useState} from 'react';
import {connect} from 'react-redux';
import {Typography} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import {SecondaryButton} from '../common/StyledButtons';
import {PersonOutline, EmailOutlined, SupervisorAccountOutlined} from '@material-ui/icons';
import Modal from '../common/Modal';
import ChangePasswordForm from './ChangePasswordForm';
import {addFlashMessage} from '../../actions/flash-message';

function Settings(props) {
    const {user, addFlashMessage} = props;
    const [open, setOpen] = useState(false);

    const successAction = (message, success) => {
        addFlashMessage(message, success ? 'success' : 'error');
    };

    return (
        <div className={'content-box'}>
            <Modal
                title=""
                onClose={() => setOpen(false)}
                open={open}
            >
                <ChangePasswordForm
                    addFlashMessage={addFlashMessage}
                    cancelAction={() => setOpen(false)}
                    successAction={successAction}/>
            </Modal>
            <h1 className="section-header">
                <div className="section-title">User Settings</div>
            </h1>
            <SettingsHeader user={user}/>
            <SecondaryButton onClick={() => setOpen(true)}>Change Password</SecondaryButton>
        </div>
    );
}

function SettingsHeader(props) {
    const {user} = props;
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}/>
            <Grid container item xs={4} spacing={0}>
                <Grid item xs={1}>
                    <PersonOutline/>
                </Grid>
                <Grid item xs={3}>
                    <Typography>Username </Typography>
                </Grid>
            </Grid>
            <Grid item xs={8}>
                <Typography>{user.name}</Typography>
            </Grid>
            <Grid container item xs={4} spacing={0}>
                <Grid item xs={1}>
                    <EmailOutlined/>
                </Grid>
                <Grid item xs={3}>
                    <Typography>Email </Typography>
                </Grid>
            </Grid>
            <Grid item xs={8}>
                <Typography>{user.email}</Typography>
            </Grid>
            <Grid container item xs={4} spacing={0}>
                <Grid item xs={1}>
                    <SupervisorAccountOutlined/>
                </Grid>
                <Grid item xs={3}>
                    <Typography>Role </Typography>
                </Grid>
            </Grid>
            <Grid item xs={8}>
                <Typography>{user.role}</Typography>
            </Grid>
            <Grid item xs={12}/>
        </Grid>
    );
}

const mapDispatchToProps = (dispatch) => ({
    addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
});

export default (connect(
    ({account: {user}}) => ({
        user,
    }), mapDispatchToProps)(Settings));